import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Typography, TextField, Button, useTheme } from '@material-ui/core'
import { useAuth } from 'auth'

const ConfirmResetPassword = ({
  setView,
  state,
  setState,
  fetching,
  error,
  setError,
  setFetching,
  authErrorMapping,
}) => {
  const theme = useTheme()
  const { t } = useTranslation('auth')
  const { AmplifyAuth } = useAuth()

  const handleInputChange = (event) => {
    setState((s) => ({ ...s, [event.target.name]: event.target.value }))
  }

  const handleConfirmResetPassword = async (event) => {
    try {
      setFetching(true)
      setError(null)
      if (state.password !== state.passwordConfirm) {
        setError('PasswordsNotEqual')
        return
      }
      await AmplifyAuth.forgotPasswordSubmit(
        state.email,
        state.confirmCode,
        state.password
      )

      setState((s) => ({
        ...s,
        confirmCode: '',
        password: '',
        passwordConfirm: '',
      }))

      setView('resetPasswordSuccess')
    } catch (e) {
      if (e.name === 'AuthError') {
        setError(authErrorMapping[e.log] || e.log)
        return
      }
      if (e.code === 'CodeMismatchException') {
        setError(e.code)
        return
      }
      if (e.code === 'ExpiredCodeException') {
        setError(e.code)
        return
      }
      console.log(e)
      setError(e.code)
    } finally {
      setFetching(false)
    }
  }

  return (
    <Box
      width="100%"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      p={[3]}
      pt={3}
    >
      <Typography
        align="center"
        style={{ color: theme.palette.primary.dark }}
        mb={5}
      >
        {t('messageConfirmResetPassword', state)}
      </Typography>
      <TextField
        placeholder={t('attributes.confirmCode.placeholder')}
        label={t('attributes.confirmCode.label')}
        name="confirmCode"
        value={state.confirmCode}
        onChange={handleInputChange}
        disabled={fetching}
      />
      <Box mb={5} />
      <TextField
        placeholder={t('attributes.password.placeholder')}
        label={t('attributes.password.label')}
        type="password"
        name="password"
        value={state.password}
        onChange={handleInputChange}
        disabled={fetching}
      />
      <Box mb={5} />
      <TextField
        placeholder={t('attributes.passwordConfirm.placeholder')}
        label={t('attributes.passwordConfirm.label')}
        type="password"
        name="passwordConfirm"
        value={state.passwordConfirm}
        onChange={handleInputChange}
        disabled={fetching}
      />
      <Box mb={5} />
      <Button
        color="primary"
        variant="contained"
        disabled={fetching}
        onClick={handleConfirmResetPassword}
      >
        {t('buttons.confirmResetPassword')}
      </Button>
      {error && (
        <Typography
          align="center"
          p={[3]}
          style={{ color: theme.palette.error.light }}
        >
          {t(`errors.${error}`, state)}
        </Typography>
      )}
    </Box>
  )
}

ConfirmResetPassword.footerProps = {
  message: 'messageChangeAccount',
  goto: 'signIn',
  resetForm: {
    confirmCode: '',
    password: '',
    passwordConfirm: '',
  },
}

export default ConfirmResetPassword
